import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, FileText } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-foreground text-white py-16" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-xl font-heading font-semibold mb-4">Psychotherapy with Anvita</h3>
            <p className="text-white/70 text-sm leading-relaxed">
              Professional therapy services for individuals, couples, and adolescents. Creating a safe space for healing and growth.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium mb-4">Quick Links</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li>
                <Link to="/" className="hover:text-white transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white transition-colors">About</Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-medium mb-4">Resources</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li>
                <Link to="/book" className="hover:text-white transition-colors">Book a Session</Link>
              </li>
              <li>
                <Link to="/discovery" className="hover:text-white transition-colors">Discovery Call</Link>
              </li>
              <li>
                <a 
                  href="https://docs.google.com/forms/d/e/1FAIpQLSccQdWvf4Vi7SYZh_2ijAZPKB0qsUY58NXGlwX0gc2VTK_hwA/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors flex items-center gap-2"
                  data-testid="footer-intake-form"
                >
                  <FileText size={14} />
                  New Client Intake Form
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-medium mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-center gap-2">
                <Mail size={14} />
                <a href="mailto:therapywithanvitasethi@gmail.com" className="hover:text-white transition-colors">
                  therapywithanvitasethi@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={14} className="mt-1 flex-shrink-0" />
                <span>Online sessions available worldwide</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/50">
              © {new Date().getFullYear()} Psychotherapy with Anvita. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm text-white/50">
              <Link to="/terms" className="hover:text-white transition-colors">Terms of Use</Link>
              <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/refund-policy" className="hover:text-white transition-colors">Refund & Cancellation</Link>
            </div>
          </div>
          
          {/* Crisis Disclaimer */}
          <div className="mt-6 text-center">
            <p className="text-xs text-white/40">
              Mental Health Services are not suited during a crisis. Please contact a local emergency service, in case of immediate distress.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
